import { render, staticRenderFns } from "./BookingCancellation.vue?vue&type=template&id=a226c20c&scoped=true"
import script from "./BookingCancellation.vue?vue&type=script&lang=ts"
export * from "./BookingCancellation.vue?vue&type=script&lang=ts"
import style0 from "./BookingCancellation.vue?vue&type=style&index=0&id=a226c20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a226c20c",
  null
  
)

export default component.exports